module.exports = __webpack_public_path__ + "img/rows-03.5702b483.svg";